/** Status values for active and inactive. */
export default {
  active: 1,
  inactive: 2,
};
